import React, { useMemo } from "react";
import { capitalize, getService } from "../../../helper";
import VmoButton from "../../Elements/VmoButton/VmoButton";
import VmoModal from "../../Modules/Modal/VmoModal";
import VmoModalContent from "../../Modules/Modal/VmoModalContent";
import VmoContainer from "../../Elements/VmoContainer";
import VmoDivider from "../../Elements/VmoDivider";
import VmoGrid from "../../Collections/VmoGrid/VmoGrid";
import VmoGridRow from "../../Collections/VmoGrid/VmoGridRow";
import VmoGridColumn from "../../Collections/VmoGrid/VmoGridColumn";
import NewProductImage from "../../../assets/NewProductImage";
import PropTypes from "prop-types";

function capitalizeFirstLetter(string) {
  if (!string) return "";
  return string.charAt(0).toUpperCase() + string.slice(1);
}

const SingleProductModal = ({
  singleProductModal,
  setSingleProductModal,
  productData,
  handleProductSubscribe = () => null,
  userRole,
  isStartFreeTrailLoading = false,
}) => {
  const { service, description, features = [] } = productData;

  const allowSubscribeRole = useMemo(() => {
    return ["owner", "admin"].includes(userRole);
  }, [userRole]);

  return (
    <VmoModal
      open={singleProductModal}
      onClose={() => setSingleProductModal(false)}
      className="single-product-modal"
      closeIcon
    >
      <VmoModalContent className="vmo-modal-body">
        <VmoContainer>
          <h3 className="text-cap">
            Veemo {capitalizeFirstLetter(getService(service))}
          </h3>
          <VmoDivider />
          <VmoGrid centered relaxed="very">
            <VmoGridRow>
              <div className="single-product-body">
                <NewProductImage />
                <h3>Welcome to Veemo {capitalize(getService(service))}</h3>
                <h5>{description}</h5>
                {allowSubscribeRole ? (
                  <VmoButton
                    primary
                    className="text-cap"
                    loading={isStartFreeTrailLoading}
                    disabled={isStartFreeTrailLoading}
                    onClick={() => handleProductSubscribe({ service })}
                  >
                    Start 14 Days Free Trial
                  </VmoButton>
                ) : (
                  <VmoButton primary disabled>
                    To Enable Please Contact Admin
                  </VmoButton>
                )}
              </div>
            </VmoGridRow>

            <VmoGridRow columns={3}>
              {features?.map(({ title, description }, index) => {
                return (
                  <VmoGridColumn key={index} className="my-4">
                    <div className="single-product-head">{title}</div>
                    <div className="single-product-sub-head">{description}</div>
                  </VmoGridColumn>
                );
              })}
            </VmoGridRow>
          </VmoGrid>
        </VmoContainer>
      </VmoModalContent>
    </VmoModal>
  );
};
SingleProductModal.defaultProps = {
  singleProductModal: false,
  setSingleProductModal: () => null,
  productData: {},
  handleProductSubscribe: () => null,
  userRole: "",
  isStartFreeTrailLoading: false,
};

SingleProductModal.propTypes = {
  singleProductModal: PropTypes.bool.isRequired,
  setSingleProductModal: PropTypes.func.isRequired,
  productData: PropTypes.object.isRequired,
  handleProductSubscribe: PropTypes.func,
  userRole: PropTypes.string.isRequired,
  isStartFreeTrailLoading: PropTypes.bool,
};
export default SingleProductModal;
